import React from 'react';

import { GlobalMenu, PageFooter } from '../components';

const DefaultLayout: React.FC = props => {
    return(
        <div className="layout-wrap">
            <GlobalMenu {...props} />
            {props.children}
            <PageFooter />
        </div>
    );
}



export default DefaultLayout;